__turbopack_context__.v({
  "panelImageWrapper": "tabItemsImage-module-scss-module__eMjrEW__panelImageWrapper",
  "panelImg": "tabItemsImage-module-scss-module__eMjrEW__panelImg",
});
